import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { Modal } from "../../../../theme/Component/Modal";
import useModal, { MODAL_XL } from "../../../../theme/Component/hooks/useModal";
import { SalesOrderItem } from "./SalesOrderItem";

interface Props {
    idSalesOrder: number;
    salesOrderDate: any;
    idSelector?: number | null;
    render?: string;
    label?: string;
    onChange: (value: any) => void;
    disabled?: boolean;
}

export const EditorSalesOrderItem = ({
    idSalesOrder,
    salesOrderDate,
    idSelector,
    render,
    label,
    onChange,
    disabled,
}: Props) => {
    const modal = useModal("Catálogo de productos de la oportunidad", MODAL_XL);
    const [selected, setSelected] = useState<any>({});
    const [displayValue, setDisplayValue] = useState("");

    const getDisplayValue = (item: any) => {
        if (item?.IDSalesOrderItem == null) return "";
        return `${item.IDSalesOrderItem} - ${item.Description ?? ""}`;
    };

    useEffect(() => {
        if (idSelector != null) {
            setSelected({ IDSalesOrderItem: idSelector });
            setDisplayValue(render || `${idSelector}`);
        } else {
            setSelected({});
            setDisplayValue("");
        }
    }, [idSelector, render]);

    const selectValue = () => {
        if (selected.IDSalesOrderItem == null) {
            toast.error("Seleccione un producto de la oportunidad");
            return;
        }

        setDisplayValue(getDisplayValue(selected));
        onChange(selected);
        modal.close();
    };

    return (
        <>
            {label !== " " && <label>{label ?? "Producto de la Oportunidad"}</label>}
            <div
                className={`form-control text-wrap ${disabled ? "bg-light text-muted" : "cursor-pointer"}`}
                style={{ minHeight: "35px" }}
                onClick={() => !disabled && modal.open()}
            >
                {displayValue || <span>Seleccionar...</span>}
            </div>

            <Modal
                modal={modal.modal}
                updateModal={modal.setModal}
                eventModal={selectValue}
                onSubmitLabel="Seleccionar"
            >
                <SalesOrderItem
                    isModal
                    idSalesOrder={idSalesOrder}
                    salesOrderDate={salesOrderDate}
                    _onChange={setSelected}
                />
            </Modal>
        </>
    );
};
